import ForgotPasswordForm from 'profile/login/forms/ForgotPasswordForm';

const ReturningCustomer = (props) => {
  const { slug } = props;
  return (
    <div className="c7-account-login--returning-customer">
      <h4>Forgot Password</h4>
      <ForgotPasswordForm
        redirectLink={`/club/${slug}/signup`}
        loginLink={`/club/${slug}/login`}
      />
    </div>
  );
};

export default ReturningCustomer;
